import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../shared/services/login.service';
import { LoginResponse } from '../shared/models/auth.model';
import { UserRole } from '../shared/models/user-role.enum';
import { environment } from '../../environments/environment';

@Component({
  selector: 'ins-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form!: FormGroup;
  loading = false;
  submitted = false;
  showLoginError = false;
  loginError = '';
  enableCustomerPortal = environment.EnableCustomerPortal;

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.loginService.clearAuthData();
  }

  get theForm() {
    return this.form.controls;
  }

  userLogin(): void {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    this.showLoginError = false;

    this.loginService.clearAuthData();

    this.loginService
      .login(this.theForm['username'].value, this.theForm['password'].value)
      .subscribe({
        next: (result: LoginResponse) => {
          if (result && result.user) {
            if (result.user.roles.includes(UserRole.Customer) && !environment.EnableCustomerPortal) {
              this.showLoginError = true;
              this.loginError = 'Customer portal is currently unavailable. Please contact us at 1.800.444.3584 for assistance.';
              this.loading = false;
              this.loginService.clearAuthData();
              return;
            }
            const defaultRoute = this.getDefaultRouteForUser(result.user.roles);
            this.loading = false;
            this.router.navigate([defaultRoute]);
          } else {
            this.showLoginError = true;
            this.loginError = 'Login response format error. Please try again.';
            this.loading = false;
          }
        },
        error: (err) => {
          this.loginError =
            err?.error?.error || 'Login Failed. Verify User Name/Password are correct or click Forgot Password.';
          this.showLoginError = true;
          this.loading = false;
        },
      });
  }

  private getDefaultRouteForUser(roles: string[]): string {
    if (roles.includes(UserRole.Customer)) {
      return '/customer';
    } else if (roles.includes(UserRole.Agent)) {
      return '/agent';
    } else if (roles.includes(UserRole.Admin)) {
      return '/admin';
    }
    return '/home';
  }
}
